import React, { FunctionComponent } from 'react';
import ImageHeaderLayout from '@/pages/layouts/ImageHeaderLayout';
import StaticPageHeader from '@/components/layout/headers/StaticPageHeader';
import { getStaticPage, StaticPageStructure } from '@/pageGeneration/services/prismicApi/staticPagesApi';
import PageSeo from '@/components/seo/PageSeo';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import useCustomPageViews from '@/utility/eventTracking/useCustomPageViews';
import { PAGE_CATEGORIES } from '@/utility/eventTracking/constants';
import UnprotectedPage from '@/components/navigation/UnprotectedPage';
import FaqPageComponent from '@/components/pageComponents/FaqPageComponent';

interface IProps {
  pageStructure: StaticPageStructure;
}

const PAGE_ID = 'faq';

const Realtime: FunctionComponent<IProps> = ({ pageStructure }) => {
  useCustomPageViews({ category: PAGE_CATEGORIES.STATIC, name: 'FAQ' });
  return (
    <UnprotectedPage>
      <ImageHeaderLayout
        imageUrl={pageStructure.heroImage.url}
        headerContent={<StaticPageHeader title={pageStructure.title} subtitle={pageStructure.subtitle} />}
      >
        <PageSeo title={pageStructure.title} />
        <FaqPageComponent contentTop={pageStructure.contentTop} />
      </ImageHeaderLayout>
    </UnprotectedPage>
  );
};

export async function getStaticProps() {
  try {
    const pageStructureData = await getStaticPage(PAGE_ID);

    return packageStaticProps({
      pageStructure: pageStructureData,
    });
  } catch (e) {
    return {
      notFound: true,
    };
  }
}

export default Realtime;
